<template>
  <div class="body-container">
    <main class="login">
      <div class="container">
        <h1>Administration</h1>
        <form action="" @submit.prevent="signin">
          <div class="username">
            <label for="email">{{ $t("Nom d'utilisateur") }}</label>
            <input id="email" type="text" name="text" v-model="username" />
          </div>
          <div class="password">
            <label for="password">{{ $t("Mot de passe") }}</label>
            <input id="password" type="password" name="password" v-model="password" />
          </div>
          <div class="error" v-if="error">{{ error }}</div>
          <button class="cta">{{ $t("Se connecter") }}</button>
        </form>
      </div>
    </main>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
export default Vue.extend({
  name: "Login",
  data() {
    return {
      username: "SPezzin",
      password: "",
      error: null,
      loading: false,
    };
  },
  methods: {

    signin() {
      console.log("ok");
      this.$axios
        .post("/login/check", {
          username: this.username,
          password: this.password,
        })
        .then((res) => {
          if (res.data) {
            this.$cookies.set("jkt", res.data.jkt);
            this.$cookies.set("usr_lang", "es");
            this.$store.commit("TOGGLE_MENU", true);
            this.$router.push({ name: "projects" });
          } else {
            this.error = "Nom d'utilisateur ou mot de passe incorrect";
          }
        })
        .catch((res) => {
          this.error = "Nom d'utilisateur ou mot de passe incorrect";
        });
    },
  },
});
</script>

<style scoped>
.password {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
